import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommentHelpersService } from 'src/app/components/observation-comments/services/comment-helpers/comment-helpers.service';
import { ObservationCommentService } from 'src/app/components/observation-comments/services/observation-comment/observation-comment.service';
import { ModalService } from 'src/app/modals/modal.service';
import { FileAttachment } from 'src/app/model/attachment/file-attachment.model';
import { PermissionTypes } from 'src/app/model/enum/permission-types.enum';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { UserSummaryPermissions } from 'src/app/model/observation/user-summary-permisions.model';
import { FileService } from 'src/app/services/file.service';
import { PermissionsHelperService } from 'src/app/services/permissions-helper/permissions-helper.service';

@Component({
  selector: 'observation-attachments',
  templateUrl: './observation-attachments.component.html',
  styleUrls: ['./observation-attachments.component.scss']
})
export class ObservationAttachmentsComponent implements OnInit, OnDestroy {

  @Input() observationFiles: FileAttachment[] = [];
  @Input() observationSummary?: ObservationSummaryDTO;
  @Input() userSummaryPermissions?: UserSummaryPermissions;

  get observationType() {
    return this.commentHelperService.adjustObservationType(this.observationSummary?.itemType);
  }

  private edlCommentsSubscription?: Subscription;

  constructor(private modalService:ModalService,
    private observationCommentService: ObservationCommentService,
    private permissionsHelperService: PermissionsHelperService,
    private fileService: FileService,
    private commentHelperService: CommentHelpersService
    ) { }

  ngOnInit(): void {
    if (this.permissionsHelperService.doIHaveAllPermissions([PermissionTypes.FILE_ATTACHMENTS])) {
      this.edlCommentsSubscription =  this.observationCommentService.edlCommentAttachmentSubject.subscribe((comments) => this.updateObservationFiles());
    }
  }

  updateObservationFiles(){
    this.fileService.getFilesForObservation(this.observationType!, this.observationSummary?.observationId!).subscribe(
      {
        next: (resp:any)=> {
          this.observationFiles = resp;

        }
      }
    )
  }

  ngOnDestroy(): void {
    this.edlCommentsSubscription?.unsubscribe();
  }

  openAttachmentModal(){
    this.modalService.openFileAttachmentsModal(false, this.observationFiles, this.observationSummary!, "", undefined, this.observationCommentService.filters.isReadOnly);
  }


  canAttachFilesToObservation() {
    return this.observationSummary?.permissions.canAttach;
  }


}
